import { useSearchParams } from '@/hooks/useSearchParams';

export const useLocationViewState = () => {
    const searchParams = useSearchParams();

    return searchParams.get('view-mode') || 'result-list';
};
